import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconCalendar: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width={$size} height={$size} viewBox="0 0 48 48" fill="none">
      <path
        d="M39 7.5H9C8.17157 7.5 7.5 8.17157 7.5 9V39C7.5 39.8284 8.17157 40.5 9 40.5H39C39.8284 40.5 40.5 39.8284 40.5 39V9C40.5 8.17157 39.8284 7.5 39 7.5Z"
        stroke={rest?.$color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M33 4.5V10.5" stroke={rest?.$color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 4.5V10.5" stroke={rest?.$color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 16.5H40.5" stroke={rest?.$color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </IconStyled>
);

IconCalendar.defaultProps = iconDefaultProps;
IconCalendar.displayName = 'IconCalendar';

export default IconCalendar;
